import {
	generateDisclosuresSSOLoginUrl,
	navigationLinking,
} from './navigation'
import { orderBy } from 'lodash'
import { currencyToFloat } from './formattingUtils'
import * as FileSaver from 'file-saver'
import * as XLSX from 'xlsx'

export const applyMask = (value, maskType) => {
	if (!value) return value
	let x, parts, val
	switch (maskType) {
		case 'ssn':
			x = value
				.replace(/\D/g, '')
				.match(/(\d{0,3})(\d{0,2})(\d{0,4})/)
			return !x[2]
				? x[1]
				: x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '')
		case 'date':
			x = value
				.replace(/\D/g, '')
				.match(/(\d{0,2})(\d{0,2})(\d{0,4})/)
			return !x[2]
				? x[1]
				: x[1] + '/' + x[2] + (x[3] ? '/' + x[3] : '')
		case 'futureDate':
			x = value
				.replace(/\D/g, '')
				.match(/(\d{0,2})(\d{0,2})(\d{0,4})/)
			return !x[2]
				? x[1]
				: x[1] + '/' + x[2] + (x[3] ? '/' + x[3] : '')
		case 'dob':
			x = value
				.replace(/\D/g, '')
				.match(/(\d{0,2})(\d{0,2})(\d{0,4})/)
			return !x[2]
				? x[1]
				: x[1] + '/' + x[2] + (x[3] ? '/' + x[3] : '')
		case 'phone':
			x = value
				.replace(/[+]1|\D/g, '')
				.match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
			return !x[2]
				? x[1]
				: '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
		case 'currency':
			return value
				.toString()
				.replace(/[^0-9]/g, '')
				.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
		case 'fullCurrency':
			const dotCount = (value.toString().match(/\./g) || []).length
			parts = value
				.toString()
				.replace(/[^0-9.]/g, '')
				.split('.')
			if (parts[1]) {
				parts[1] = parts[1].substring(0, 2)
				parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
				val = `${parts[0]}.${parts[1]}`
			} else {
				val = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
				if (value.toString().includes('.') && dotCount < 2)
					val = val + '.'
			}
			return val
		case 'alpha':
			return value.replace(/[^a-z ,-]+/gi, '')
		case 'numeric':
			return value.replace(/\D/g, '')
		case 'alphanumeric':
			return value.replace(/[^\w\s,-]/gi, '')
		case 'year':
			return value.replace(/\D/g, '').substring(0, 4)
		case 'years':
			return value.replace(/\D/g, '')
		case 'months':
			return value.replace(/\D/g, '')
		case 'positive':
			return value.replace(/\D/g, '')
		case 'email':
			return value.trim().toLowerCase()
		default:
			return value
	}
}

export const adminMenu = [
	//{ name: 'My Dashboard', id: 'Dashboard', route: navigationViews.Portal },
	{
		name: 'My Profile',
		id: 'MyProfile',
		route: navigationLinking.UserProfile,
	},
	{ name: 'Log Out', id: 'SignOut' },
]

export const getTitleByRole = (role) => {
	const titles = ['', '', '', 'Loan Officer', 'Realtor']
	return titles[role]
}

export const getTitleByEntityType = (role) => {
	const titles = ['', '', '', 'Loan Officer', 'Realtor']
	return titles[role]
}

export const getFilters = (entity, searchText) => {
	if (searchText === 'Search...') return (td) => td
	searchText = searchText.toLowerCase()
	switch (entity) {
		case 'User':
			return (td) =>
				td.firstName?.toLowerCase().includes(searchText) ||
				td.lastName?.toLowerCase().includes(searchText) ||
				`${td.firstName} ${td.lastName}`
					.toLowerCase()
					.includes(searchText) ||
				td.email?.toLowerCase().includes(searchText) ||
				td.nmlsid?.toString().includes(searchText)
		case 'LoanOfficer':
			return (td) =>
				td.firstName?.toLowerCase().includes(searchText) ||
				td.lastName?.toLowerCase().includes(searchText) ||
				`${td.firstName} ${td.lastName}`
					.toLowerCase()
					.includes(searchText) ||
				td.email?.toLowerCase().includes(searchText) ||
				td.title?.toLowerCase().includes(searchText) ||
				td.nmlsid?.toString().includes(searchText)
		case 'Branch':
			return (td) =>
				td.name.includes(searchText) ||
				td.nmlsid?.toString().includes(searchText) ||
				td.url?.includes(searchText)
		case 'Corporate':
			return (td) =>
				td.name.toLowerCase().includes(searchText.toLowerCase()) ||
				td.nmlsid?.toString().includes(searchText) ||
				td.url?.includes(searchText)
		case 'LoanApplication':
			return (td) =>
				td.firstName?.toLowerCase().includes(searchText) ||
				td.lastName?.toLowerCase().includes(searchText) ||
				`${td.firstName} ${td.lastName}`
					.toLowerCase()
					.includes(searchText) ||
				td.loanOfficer?.toLowerCase().includes(searchText) ||
				td.url?.includes(searchText) ||
				td.loanNumber?.toLowerCase().includes(searchText)
		case 'Rule':
			return (td) =>
				td.name?.toLowerCase().includes(searchText) ||
				td.description?.toLowerCase().includes(searchText)
		case 'Partners':
			return (td) =>
				td.firstName?.toLowerCase().includes(searchText) ||
				td.lastName?.toLowerCase().includes(searchText)
		case 'Partner':
			return (td) =>
				td.firstName?.toLowerCase().includes(searchText) ||
				td.lastName?.toLowerCase().includes(searchText)
		case 'Task':
			return (td) =>
				td.taskName?.toLowerCase().toString().includes(searchText) ||
				td.taskDescription
					?.toLowerCase()
					.toString()
					.includes(searchText) ||
				td.taskLOSIdentifier
					?.toLowerCase()
					.toString()
					.includes(searchText)
		case 'RequestQueue':
			return (td) =>
				td.userEmail?.toLowerCase().toString().includes(searchText) ||
				td.endpoint?.toLowerCase().toString().includes(searchText) ||
				td.errorMessage
					?.toLowerCase()
					.toString()
					.includes(searchText) ||
				td.status?.toLowerCase().toString().includes(searchText) ||
				td.requestKey?.toLowerCase().toString().includes(searchText)
		case 'NotificationTemplate':
			return (td) =>
				td.name?.toLowerCase().toString().includes(searchText) ||
				td.description?.toLowerCase().toString().includes(searchText)
		case 'DocumentTemplate':
			return (td) =>
				td.name?.toLowerCase().toString().includes(searchText) ||
				td.description
					?.toLowerCase()
					.toString()
					.includes(searchText) ||
				td.type?.toLowerCase().toString().includes(searchText)
		case 'Workflow':
			return (td) =>
				td.name?.toLowerCase().toString().includes(searchText) ||
				td.description
					?.toLowerCase()
					.toString()
					.includes(searchText) ||
				td.type?.toLowerCase().toString().includes(searchText)
	}
}

export const generateRandomPassword = () => {
	let pass = ''
	const allowed =
		'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
		'abcdefghijklmnopqrstuvwxyz0123456789!@#$_-!'

	for (let i = 1; i <= 100; i++) {
		let char = Math.floor(Math.random() * allowed.length + 1)

		pass += allowed.charAt(char)
	}

	return pass
}

export const isJsonString = (str) => {
	try {
		JSON.parse(str)
	} catch (e) {
		return false
	}
	return true
}

export const setAutoFocusProp = (question) => {
	switch (question.type) {
		case 'group':
			if (question?.items?.length) {
				if (question?.items[0]?.type === 'text') {
					question.items[0].autoFocus = true
				} else if (
					question?.items[0]?.type === 'row' &&
					question?.items[0]?.items[0]?.type === 'text'
				) {
					question.items[0].items[0].autoFocus = true
				}
			}
			break
		case 'text':
			question.autoFocus = true
			break
	}
}

// MB -> Bytes
export const fileMBSizes = {
	20: 20971520,
	150: 157286400,
}

export const isiOSAndSafariBrowser = () => {
	const isSafariBrowser = () =>
		navigator.userAgent.indexOf('Safari') > -1 &&
		navigator.userAgent.indexOf('Chrome') <= -1
	const userAgent =
		navigator.userAgent || navigator.vendor || window.opera
	return (
		/iPad|iPhone|iPod/.test(userAgent) &&
		!window.MSStream &&
		isSafariBrowser()
	)
}

export const siteConfigurationModel = {
	entityID: null,
	entityType: 0,
	introduction: '',
	introductionTitle: '',
	email: '',
	url: '',
	name: '',
	nmlsid: '',
	address: '',
	address2: '',
	city: '',
	state: '',
	zip: '',
	phone: '',
	fax: '',
	tollFree: '',
	headerAlignment: '',
	logoUrl: '',
	darkModeLogoUrl: '',
	portalLogoUrl: '',
	darkModePortalLogoUrl: '',
	mobileAppLogoUrl: '',
	iconUrl: '',
	darkModeIconUrl: '',
	bannerUrl: '',
	secondaryBannerUrl: '',
	licenseInfoUrl: '',
	contactUsUrl: '',
	profilePhotoUrl: '',
	locationImageUrl: '',
	primaryColor: '',
	darkModePrimaryColor: '',
	secondaryColor: '',
	darkModeSecondaryColor: '',
	backgroundColor: '',
	backgroundImageUrl: '',
	textColor: '',
	iconColor: '',
	licenses: [],
	termsUrl: '',
	companyUrl: '',
	companyName: '',
	companyAddress: '',
	companyAddress2: '',
	companyCity: '',
	companyState: '',
	companyZip: '',
	companyPhone: '',
	companyFax: '',
	twitterUrl: '',
	facebookUrl: '',
	linkedInUrl: '',
	instagramUrl: '',
	youTubeUrl: '',
	privacyPolicyUrl: '',
	googleAnalyticsKey: '',
	losUserID: '',
	eppsUserName: '',
	footerDisclaimerText1: '',
	footerDisclaimerText2: '',
	byPhoneStaticIconID: '',
	byPhoneAnimatedIconID: '',
	calculatorStaticIconID: '',
	calculatorAnimatedIconID: '',
	shortAppStaticIconID: '',
	shortAppAnimatedIconID: '',
	fullAppStaticIconID: '',
	fullAppAnimatedIconID: '',
	rulesStaticIconID: '',
	rulesAnimatedIconID: '',
	myProfileStaticIconID: '',
	myProfileAnimatedIconID: '',
	accountSettingsStaticIconID: '',
	accountSettingsAnimatedIconID: '',
	brandStaticIconID: '',
	brandAnimatedIconID: '',
	branchesStaticIconID: '',
	branchesAnimatedIconID: '',
	loanOfficersStaticIconID: '',
	loanOfficersAnimatedIconID: '',
	usersStaticIconID: '',
	usersAnimatedIconID: '',
	pipelineStaticIconID: '',
	pipelineAnimatedIconID: '',
	loanApplicationsStaticIconID: '',
	loanApplicationsAnimatedIconID: '',
	documentsStaticIconID: '',
	documentsAnimatedIconID: '',
	dashboardStaticIconID: '',
	signInStaticIconID: '',
	signInAnimatedIconID: '',
	signOutStaticIconID: '',
	signOutAnimatedIconID: '',
	addCoBorrowerStaticIconID: '',
	addCoBorrowerAnimatedIconID: '',
	notificationsStaticIconID: '',
	notificationsAnimatedIconID: '',
	workflowsStaticIconID: '',
	workflowsAnimatedIconID: '',
	requestQueueStaticIconID: '',
	requestQueueAnimatedIconID: '',
	loanDetailsStaticIconID: '',
	loanDetailsAnimatedIconID: '',
	signatureStaticIconID: '',
	signatureAnimatedIconID: '',
	helpStaticIconID: '',
	helpAnimatedIconID: '',
	paymentStaticIconID: '',
	paymentAnimatedIconID: '',
	loConnectStaticIconID: '',
	loConnectAnimatedIconID: '',
	superShortAppStaticIconID: '',
	superShortAppAnimatedIconID: '',
	releaseNotesStaticIconID: '',
	releaseNotesAnimatedIconID: '',
	supportStaticIconID: '',
	supportAnimatedIconID: '',
	assetsStaticIconID: '',
	assetsAnimatedIconID: '',
	byPhoneStaticIcon: '',
	byPhoneAnimatedIcon: '',
	calculatorStaticIcon: '',
	calculatorAnimatedIcon: '',
	shortAppStaticIcon: '',
	shortAppAnimatedIcon: '',
	fullAppStaticIcon: '',
	fullAppAnimatedIcon: '',
	rulesStaticIcon: '',
	rulesAnimatedIcon: '',
	myProfileStaticIcon: '',
	myProfileAnimatedIcon: '',
	accountSettingsStaticIcon: '',
	accountSettingsAnimatedIcon: '',
	brandStaticIcon: '',
	brandAnimatedIcon: '',
	branchesStaticIcon: '',
	branchesAnimatedIcon: '',
	loanOfficersStaticIcon: '',
	loanOfficersAnimatedIcon: '',
	usersStaticIcon: '',
	usersAnimatedIcon: '',
	pipelineStaticIcon: '',
	pipelineAnimatedIcon: '',
	loanApplicationsStaticIcon: '',
	loanApplicationsAnimatedIcon: '',
	documentsStaticIcon: '',
	documentsAnimatedIcon: '',
	dashboardStaticIcon: '',
	dashboardAnimatedIcon: '',
	signInStaticIcon: '',
	signInAnimatedIcon: '',
	signOutStaticIcon: '',
	signOutAnimatedIcon: '',
	addCoBorrowerStaticIcon: '',
	addCoBorrowerAnimatedIcon: '',
	notificationsStaticIcon: '',
	notificationsAnimatedIcon: '',
	workflowsStaticIcon: '',
	workflowsAnimatedIcon: '',
	requestQueueStaticIcon: '',
	requestQueueAnimatedIcon: '',
	loanDetailsStaticIcon: '',
	loanDetailsAnimatedIcon: '',
	signatureStaticIcon: '',
	signatureAnimatedIcon: '',
	helpStaticIcon: '',
	helpAnimatedIcon: '',
	paymentStaticIcon: '',
	paymentAnimatedIcon: '',
	loConnectStaticIcon: '',
	loConnectAnimatedIcon: '',
	superShortAppStaticIcon: '',
	superShortAppAnimatedIcon: '',
	assetsStaticIcon: '',
	assetsAnimatedIcon: '',
	releaseNotesStaticIcon: '',
	releaseNotesAnimatedIcon: '',
	supportStaticIcon: '',
	supportAnimatedIcon: '',
	counties: '',
	identityProvider: '',
	disclosuresSSOSiteID: '',
	loanChannel: '',
	loanFolder: '',
	loanTemplate: '',
	irsVerificationUrl: '',
	ccEmails: '',
	byPhoneTitle: '',
	byPhoneSubtitle: '',
	shortAppTitle: '',
	shortAppSubtitle: '',
	fullAppTitle: '',
	fullAppSubtitle: '',
	spanishPrequalTitle: '',
	spanishPrequalSubtitle: '',
	spanishFullAppTitle: '',
	spanishFullAppSubtitle: '',
	documentTemplatesStaticIcon: '',
	documentTemplatesAnimatedIcon: '',
	calendarUrl: '',
	surveysUrl: '',
	enabledServices: {
		alexa: false,
		borrowerMissions: false,
		borrowerTasks: false,
		docusign: false,
		disclosures: false,
		documents: false,
		loanCalculator: false,
		emailNotifications: false,
		fullApp: false,
		mobileApp: false,
		mobilePrequal: false,
		rates: false,
		ringCentral: false,
		socialSurvey: false,
		spanishPrequal: false,
		spanishFullApp: false,
		voa: false,
		voe: false,
		voi: false,
		voc: false,
		textNotifications: false,
		prequalLetter: false,
		payments: false,
		leadApp: false,
		loanStatus: false,
		loanAndProperty: true,
		personalInformation: true,
		employment: true,
		assets: true,
		realEstate: true,
		loanDetails: true,
		encompassWeb: true,
		support: true,
		leads: true,
		openHouseForm: false,
		listingOfferForm: false,
		listings: false,
		automatedServiceOrders: false,
	},
	modules: [],
}

export const siteConfigurationModelWithNulls = {
	...siteConfigurationModel,
	enabledServices: {
		alexa: null,
		borrowerMissions: null,
		borrowerTasks: null,
		docusign: null,
		disclosures: null,
		documents: null,
		loanCalculator: null,
		emailNotifications: null,
		fullApp: null,
		mobileApp: null,
		mobilePrequal: null,
		rates: null,
		ringCentral: null,
		socialSurvey: null,
		spanishPrequal: null,
		spanishFullApp: null,
		voa: null,
		voe: null,
		voi: null,
		voc: null,
		textNotifications: null,
		prequalLetter: null,
		payments: null,
		leadApp: null,
		loanStatus: null,
		loanAndProperty: null,
		personalInformation: null,
		employment: null,
		assets: null,
		realEstate: null,
		loanDetails: null,
		encompassWeb: null,
		support: null,
		leads: null,
		openHouseForm: null,
		listingOfferForm: null,
		listings: null,
		automatedServiceOrders: null,
	},
}

export const getExampleQuestionByType = (type) => {
	let question

	// eslint-disable-next-line default-case
	switch (type) {
		case 'photo':
			question = {
				qId: '',
				name: '',
				title: '',
				heading: '',
				question: '',
				type: 'photo',
				fieldId: '',
				isCustom: false,
				optional: false,
				target: '',
			}
			break
		case 'upload':
			question = {
				qId: '',
				name: '',
				title: '',
				heading: '',
				question: '',
				type: 'upload',
				fieldId: '',
				isCustom: false,
				optional: false,
				target: '',
			}
			break
		case 'information':
			question = {
				qId: '',
				name: '',
				title: '',
				heading: '',
				question:
					'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed eu nunc dictum, porta erat nec, convallis arcu. Cras justo risus, porttitor placerat sagittis pharetra, varius a leo. Ut ac pulvinar nulla. Cras euismod scelerisque egestas. Morbi vulputate leo augue, vel viverra ex dignissim vitae. Duis vitae nisi vitae odio bibendum efficitur. Praesent quis feugiat lacus. Vestibulum maximus lectus et interdum dapibus. Vestibulum non ligula eu ipsum accumsan faucibus. Mauris laoreet elit et quam dictum mattis. Fusce bibendum purus quis ligula consequat lobortis.',
				type: 'information',
				buttonText: "Let's Go",
				logo: true,
				fieldId: '',
				isCustom: false,
				target: '',
			}
			break
		case 'choice':
			question = {
				qId: '',
				name: '',
				title: '',
				heading: '',
				question: 'What is your question?',
				type: 'choice',
				options: [
					{
						label: 'Choice 1',
						value: 'C1',
					},
					{
						label: 'Choice 2',
						value: 'C2',
					},
					{
						label: 'Choice 3',
						value: 'C3',
					},
				],
				fieldId: '',
				isCustom: false,
				target: '',
			}
			break
		case 'boolean':
			question = {
				qId: '',
				name: '',
				title: '',
				heading: '',
				question: 'Do you have a question?',
				type: 'boolean',
				options: [
					{
						label: 'Yes',
						value: true,
					},
					{
						label: 'No',
						value: false,
					},
				],
				fieldId: '',
				isCustom: false,
				target: '',
			}
			break
		case 'text':
			question = {
				qId: '',
				name: '',
				title: '',
				heading: '',
				question: 'What is your text question?',
				type: 'text',
				placeholder: 'Enter text',
				fieldId: '',
				isCustom: false,
				target: '',
				validation: '',
			}
			break
		case 'currency':
			question = {
				qId: '',
				name: '',
				title: '',
				heading: '',
				question: 'What is your currency question?',
				type: 'text',
				placeholder: 'Enter currency',
				fieldId: '',
				isCustom: false,
				optional: false,
				target: '',
				validation: 'currency',
			}
			break
		case 'ssn':
			question = {
				qId: '',
				name: '',
				title: '',
				heading: '',
				question: 'What is your SSN?',
				type: 'text',
				placeholder: 'Enter SSN',
				fieldId: '',
				isCustom: false,
				target: '',
				validation: 'ssn',
			}
			break
		case 'picker':
			question = {
				qId: '',
				title: '',
				heading: '',
				question: 'What is your picker question?',
				type: 'picker',
				options: [
					{
						label: 'Option 1',
						value: 1,
					},
					{
						label: 'Option 2',
						value: 2,
					},
					{
						label: 'Option 3',
						value: 3,
					},
					{
						label: 'Option 4',
						value: 4,
					},
					{
						label: 'Option 5',
						value: 5,
					},
				],
				default: 'Default Picker Label',
				fieldId: '',
				isCustom: false,
				optional: false,
				name: 'Picker Name',
				target: '',
			}
			break
		case 'range':
			question = {
				qId: '',
				name: '',
				title: '',
				heading: '',
				question: 'What is your range?',
				type: 'range',
				prefix: '$',
				min: 0,
				max: 1000,
				initial: 100,
				step: 10,
				plus: true,
				validation: 'currency',
				fieldId: '',
				isCustom: false,
				optional: false,
				target: '',
			}
			break
		case 'state':
			question = {
				title: 'New Location Title',
				heading: 'New Location Heading',
				question: 'Where are you located?',
				type: 'picker',
				model: 'states',
				licensesFilter: false,
				options: [],
				qId: '',
				fieldId: '',
				isCustom: false,
				optional: false,
				name: 'State Name',
				target: '',
			}
			break
		case 'licensedState':
			question = {
				title: 'New Location Title',
				heading: 'New Location Heading',
				question: 'Where are you located?',
				type: 'picker',
				model: 'states',
				licensesFilter: true,
				options: [],
				qId: '',
				fieldId: '',
				isCustom: false,
				optional: false,
				name: 'Licensed State Name',
				target: '',
			}
			break
		case 'email':
			question = {
				question: 'What is your email?',
				type: 'text',
				validation: 'email',
				placeholder: 'Enter email',
				qId: '',
				fieldId: '',
				isCustom: false,
				optional: false,
				name: 'Email',
				target: '',
			}
			break
		case 'phone':
			question = {
				qId: 'BorrowerContactPhone',
				name: 'Borrower Contact Phone #',
				question: 'What is your question?',
				type: 'text',
				keyboardType: 'number-pad',
				placeholder: 'Enter contact number',
				fieldId: 'BorrowerContactPhone',
				isCustom: false,
				optional: false,
				validation: 'phone',
			}
			break
		case 'dob':
			question = {
				qId: '',
				name: 'Borrower DOB',
				question: 'Date of Birth',
				type: 'text',
				placeholder: 'MM/DD/YYYY',
				fieldId: '',
				isCustom: false,
				optional: false,
				maxLength: 10,
				validation: 'dob',
			}
			break
		case 'group':
			question = {
				title: 'New Group Title',
				heading: 'New Group Heading',
				type: 'group',
				items: [
					{
						qId: '',
						name: 'Group Text Question',
						question: 'What is your question?',
						type: 'text',
						keyboardType: 'number-pad',
						placeholder: 'Enter contact number',
						fieldId: '',
						isCustom: false,
						optional: false,
					},
					{
						type: 'row',
						items: [
							{
								name: '',
								qId: '',
								question: 'Row Question 1',
								type: 'text',
								optional: false,
								fieldId: '',
								isCustom: false,
								width: 200,
								style: {
									flex: 1,
								},
								validation: 'alphanumeric',
							},
							{
								qId: '',
								question: 'Row Question 2',
								type: 'text',
								optional: false,
								fieldId: 'RowQuestion2',
								isCustom: false,
								name: 'Row Question 2',
								width: 200,
								style: {
									flex: 1,
								},
								validation: 'alphanumeric',
							},
						],
					},
				],
				target: '',
				qId: '',
			}
			break
		case 'address':
			question = {
				question: 'What is your address?',
				type: 'place',
				name: 'Place',
				validation: 'googlePlaces',
				placeholder: 'Enter address',
				qId: '',
				fieldId: '',
				isCustom: false,
				target: '',
			}
			break
		case 'addressGroup':
			question = {
				question: 'Please enter the address of the ...',
				type: 'group',
				items: [
					{
						name: 'Borrower Real Estate Property Address',
						question: 'Address Lookup',
						type: 'place',
						qId: 'AddressLookup',
						fieldId: 'AddressLookup',
						isCustom: false,
						optional: false,
					},
					{
						question: 'Street Address',
						type: 'text',
						qId: 'AddressStreet',
						fieldId: 'AddressStreet',
						isCustom: false,
						name: 'Address Street',
						validation: 'alphanumeric',
					},
					{
						type: 'row',
						items: [
							{
								question: 'Unit Type',
								type: 'picker',
								default: 'Unit Type',
								options: [
									{
										label: 'Apartment',
										value: 'Apartment',
									},
									{
										label: 'Basement',
										value: 'Basement',
									},
									{
										label: 'Building',
										value: 'Building',
									},
									{
										label: 'Condo',
										value: 'Condo',
									},
									{
										label: 'Department',
										value: 'Department',
									},
									{
										label: 'Floor',
										value: 'Floor',
									},
									{
										label: 'Front',
										value: 'Front',
									},
									{
										label: 'Hangar',
										value: 'Hangar',
									},
									{
										label: 'Key',
										value: 'Key',
									},
									{
										label: 'Lobby',
										value: 'Lobby',
									},
									{
										label: 'Lot',
										value: 'Lot',
									},
									{
										label: 'Lower',
										value: 'Lower',
									},
									{
										label: 'Office',
										value: 'Office',
									},
									{
										label: 'Penthouse',
										value: 'Penthouse',
									},
									{
										label: 'Pier',
										value: 'Pier',
									},
									{
										label: 'Rear',
										value: 'Rear',
									},
									{
										label: 'Room',
										value: 'Room',
									},
									{
										label: 'Side',
										value: 'Side',
									},
									{
										label: 'Space',
										value: 'Space',
									},
									{
										label: 'Stop',
										value: 'Stop',
									},
									{
										label: 'Suite',
										value: 'Suite',
									},
									{
										label: 'Trailer',
										value: 'Trailer',
									},
									{
										label: 'Unit',
										value: 'Unit',
									},
									{
										label: 'Upper',
										value: 'Upper',
									},
								],
								optional: false,
								qId: 'AddressUnitType',
								fieldId: 'AddressUnitType',
								isCustom: false,
								name: 'Borrower Real Estate Property Address Unit Type',
								width: 200,
								style: {
									flex: 1,
								},
							},
							{
								question: 'Unit / Apt #',
								type: 'text',
								optional: true,
								qId: 'AddressUnitType',
								fieldId: 'AddressUnit',
								isCustom: false,
								name: 'Address Unit',
								width: 200,
								style: {
									flex: 1,
								},
								validation: 'alphanumeric',
							},
						],
					},
					{
						question: 'City',
						type: 'text',
						qId: 'AddressCity',
						fieldId: 'AddressCity',
						isCustom: false,
						name: 'Address City',
						validation: 'alpha',
					},
					{
						question: 'State',
						default: 'State',
						type: 'picker',
						options: [],
						model: 'states',
						licensesFilter: false,
						qId: 'AddressState',
						fieldId: 'AddressState',
						isCustom: false,
						name: 'Address State',
					},
					{
						question: 'Zip',
						type: 'text',
						qId: 'AddressZip',
						fieldId: 'AddressZip',
						isCustom: false,
						name: 'Address Zip',
						maxlength: 5,
						validation: 'numeric',
					},
				],
				target: '',
				qId: '',
				name: 'Address Group Name',
			}
			break
		case 'contactInfoGroup':
			question = {
				heading: 'Contact Information',
				type: 'group',
				items: [
					{
						question: 'First Name',
						type: 'text',
						qId: 'FirstName',
						fieldId: 'FirstName',
						isCustom: false,
						name: 'First Name',
					},
					{
						question: 'Last Name',
						type: 'text',
						qId: 'LastName',
						fieldId: 'BorrowerLastName',
						isCustom: false,
						name: 'Last Name',
					},
					{
						question: 'Middle Initial (optional)',
						type: 'text',
						qId: 'MiddleInitial',
						fieldId: 'MiddleInitial',
						isCustom: false,
						name: 'Middle Initial',
						maxLength: 1,
						optional: true,
						validation: 'alpha',
					},
					{
						question: 'Suffix (optional)',
						type: 'text',
						qId: 'Suffix',
						fieldId: 'Suffix',
						isCustom: false,
						name: 'Suffix',
						optional: true,
						validation: 'alpha',
					},
				],
				target: '',
				qId: '',
			}
			break
		case 'declaration':
			question = {
				heading: 'Borrower Declarations',
				question: 'Will you do something?',
				type: 'declaration',
				options: [
					{
						label: 'Yes',
						value: true,
					},
					{
						label: 'No',
						value: false,
					},
				],
				qId: '',
				fieldId: '',
				isCustom: false,
				name: 'Declaration',
				target: '',
			}
			break
		case 'authorization':
			question = {
				heading: 'Consent to Receive Something',
				question:
					'Your Consent To Do Something\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Integer ornare urna ac diam imperdiet maximus. Nulla facilisi. Donec sed pulvinar diam, in fermentum nunc. Duis ac scelerisque ipsum. Donec vitae gravida augue, non scelerisque nisi. Aliquam eget elementum leo. Vivamus feugiat non mi in mollis. Etiam gravida tempor egestas. Cras consectetur ultrices nisl.\n\nFusce eu scelerisque urna, a volutpat nisl. Donec augue quam, consequat in pharetra in, semper in diam. Aliquam erat volutpat. Curabitur cursus arcu vel purus consequat luctus id vitae magna. Maecenas malesuada arcu at ipsum varius molestie. Integer vitae neque purus. Phasellus urna magna, convallis et laoreet quis, congue id nisi. Sed mattis porta ex ornare consequat. Ut at dapibus justo, ac mattis metus. In nec sodales quam.\n\nCurabitur ac diam quis nunc facilisis consequat vel quis enim. Vestibulum varius mollis nulla a porttitor. Aenean sodales libero nec convallis dictum. Vivamus tempus, nisl nec placerat dictum, mauris risus auctor neque, vitae hendrerit magna diam et eros. Nam condimentum luctus ex sed aliquam. Pellentesque accumsan nisi in augue ullamcorper pretium. Vestibulum at ipsum a nulla molestie auctor at sed enim. Ut id libero vel neque imperdiet gravida rhoncus condimentum ante. Etiam luctus odio sed ornare tincidunt. Aenean pretium malesuada accumsan. Vivamus vitae eros sit amet quam ornare ullamcorper non dignissim neque. Integer eleifend nibh at nisi lacinia, sit amet efficitur nulla pellentesque. Morbi tempus risus dui, at ultricies nisi luctus eu.\n\nNulla facilisi. In vitae viverra lacus. Sed consectetur magna vitae diam volutpat, sed faucibus orci porta. Integer placerat orci nec quam aliquet sollicitudin non quis nibh. Vivamus vestibulum dui neque, vitae luctus arcu condimentum vitae. Pellentesque tempus rhoncus arcu. Mauris auctor turpis vel ultricies efficitur. Aenean pulvinar turpis dui, at malesuada ligula consectetur ut. Ut pharetra ac urna nec suscipit. Morbi dignissim nec libero at lacinia. Mauris porttitor arcu vitae lorem hendrerit, vel pulvinar lacus fringilla. Maecenas sollicitudin ipsum vitae nibh sodales, eu sagittis nunc fermentum.',
				type: 'authorization',
				qId: '',
				fieldId: '',
				isCustom: false,
				target: '',
				name: 'Authorization',
				options: [
					{
						text: 'I consent to do something',
						value: true,
					},
				],
			}
			break
	}
	return question
}

export const formatYesNo = (val) => {
	let formattedVal = ''
	if (val) {
		formattedVal = val === 'yes' ? 'Y' : 'N'
	}
	return formattedVal
}

export const boolToYN = (val) => {
	return val ? 'Y' : 'N'
}

export const getWorkflowField = async (fileName, fieldId) => {
	return new Promise((resolve, reject) => {
		import(`../workflows/${fileName}.json`)
			.then((result) => {
				const field = findWorkflowFieldById(result.default, fieldId)
				resolve(field)
			})
			.catch((e) => reject(e))
	})
}

const findWorkflowFieldById = (workflowData, fieldId) => {
	for (let i = 0; i < workflowData.length; i++) {
		const field = workflowData[i]
		if (field.fieldId === fieldId) {
			return field
		}

		if (['group', 'row'].includes(field.type) && field.items) {
			const result = findWorkflowFieldById(field.items, fieldId)
			if (result) {
				return result
			}
		}
	}
}

const getDate = (date) => {
	return typeof date === 'string' ? new Date(date) : date
}
export const daysDiff = (date1, date2) => {
	const dt1 = getDate(date1)
	const dt2 = getDate(date2)
	return Math.floor(
		(Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
			Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
			(1000 * 60 * 60 * 24)
	)
}

export const getEncompassDateString = (encompassDateStr) =>
	encompassDateStr ? encompassDateStr.replace('//', '') : null

export const replaceVars = (str, data) => {
	let vars = []
	let re = /{{([^}]+)}}/g
	let text

	while ((text = re.exec(str))) {
		vars.push(text[1])
	}

	vars.forEach((v) => {
		str = str.replace(`{{${v}}}`, data[v])
	})

	return str
}

export const exportToCsv = (
	exportData,
	fileTitle,
	standardized = true
) => {
	let data
	if (!standardized) {
		let keys = []
		// get all of the keys
		exportData.forEach(
			(row) => (keys = [...new Set([...keys, ...Object.keys(row)])])
		)
		keys.sort()
		data = exportData.map((row) => {
			const obj = {}
			keys.forEach((key) => (obj[key] = row[key] || ''))
			return obj
		})
	} else data = exportData
	const csvHeaders = [Object.keys(data[0]).join().toString()]
	let csvData = data.map((entry) => {
		let values = Object.values(entry)
		let csvRow = values.map((row) => {
			return `"${row}"`
		})
		return Object.values(csvRow).join(',')
	})

	downloadFile({
		data: [...csvHeaders, ...csvData].join('\n'),
		fileName: fileTitle + '.csv',
		fileType: 'text/csv',
	})
}

export const exportToExcel = (
	exportData,
	fileTitle,
	standardized = true
) => {
	const xlsxFileType =
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
	const xlxsFileExtension = '.xlsx'
	const ws = XLSX.utils.json_to_sheet(exportData)
	const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
	const excelBuffer = XLSX.write(wb, {
		bookType: 'xlsx',
		type: 'array',
	})
	const excelData = new Blob([excelBuffer], { type: xlsxFileType })
	FileSaver.saveAs(excelData, fileTitle + xlxsFileExtension)
}

export const exportToJSON = (exportData, fileTitle) => {
	downloadFile({
		data: JSON.stringify(exportData, undefined, 4),
		fileName: fileTitle + '.json',
		fileType: 'text/json',
	})
}

export const downloadFile = ({ data, fileName, fileType }) => {
	const blob = new Blob([data], { type: fileType })
	const a = document.createElement('a')
	a.download = fileName
	a.href = window.URL.createObjectURL(blob)

	const clickEvt = new MouseEvent('click', {
		view: window,
		bubbles: true,
		cancelable: true,
	})
	a.dispatchEvent(clickEvt)
	a.remove()
}

export const downloadBlob = (blobData, filename) => {
	const url = window.URL.createObjectURL(new Blob([blobData]))
	const link = document.createElement('a')
	link.href = url
	link.setAttribute('download', filename)
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
	window.URL.revokeObjectURL(url)
}

export const stripHtmlTags = (str) => {
	if (!str) {
		return ''
	}
	return str.replace(/(<([^>]+)>)/gi, '')
}

export const getRouteFromInvite = (invite, siteConfig) => {
	if (invite.route) {
		if (navigationLinking[invite.route])
			return `/${navigationLinking[invite.route]}`
		else if (invite.route.includes('https://')) return invite.route
		else return `/${invite.route}`
	} else {
		if (
			invite.completedLoanApplication ||
			siteConfig.enabledServices.spanishFullApp
		)
			return `/${navigationLinking.Portal}`
		else
			return `/${invite?.loanRole === 'Borrower' ? navigationLinking.Apply : navigationLinking.InviteApply}`
	}
}

export const disclosuresSSOSignIn = (siteConfig, token) => {
	return window.open(
		generateDisclosuresSSOLoginUrl(siteConfig, token),
		'_blank',
		'noopener,noreferrer'
	)
}

export const sortByField = (array, field = 'name', order = 'asc') => {
	return orderBy(array, [field], [order])
}

export const rowActions = { duplicate: 'duplicate', export: 'export' }

export const tableRowsPerPageOptions = [25, 50, 100, 200]

export function formatBytes(bytes, decimals = 2) {
	if (!+bytes) return '0 Bytes'

	const k = 1024
	const dm = decimals < 0 ? 0 : decimals
	const sizes = [
		'Bytes',
		'KB',
		'MB',
		'GB',
		'TB',
		'PB',
		'EB',
		'ZB',
		'YB',
	]

	const i = Math.floor(Math.log(bytes) / Math.log(k))

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

export const imageExists = (imageUrl) => {
	const image = new Image()
	image.src = imageUrl
	return image.width !== 0
}

export function validateURL(url, requiredDomain) {
	const requiredDomainSize = requiredDomain?.split('.').length
	const urlParts = url.split('.')
	const isMalformed = urlParts.some((part) => !part)
	if (urlParts.length < requiredDomainSize + 1 || isMalformed) {
		return `The format of the URL you've entered (${url}) is not valid.
				It should appear like branch.${requiredDomain}`
	}

	const givenUrlPrefix = urlParts.slice(0, requiredDomainSize * -1)

	if (!url.endsWith(requiredDomain)) {
		return `The domain you've entered does not match the domain of the branch.
		It should appear like ${givenUrlPrefix.join('.')}.${requiredDomain}`
	}
	return
}

export const isCurrencyStrGreaterThan = (val1, val2) => {
	if (!val1 || !val2) return false
	const val1Num = currencyToFloat(val1)
	const val2Num = currencyToFloat(val2)
	if (val1Num.isNaN() || val2Num.isNaN()) return false
	return val1Num.greaterThan(val2Num)
}
